import { render, staticRenderFns } from "./create.vue?vue&type=template&id=03d4a7d8&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
import style0 from "./create.vue?vue&type=style&index=0&id=03d4a7d8&prod&scoped=true&lang=css"
import style1 from "./create.vue?vue&type=style&index=1&id=03d4a7d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d4a7d8",
  null
  
)

export default component.exports